import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken } from '../../utils/auth';

const PublicRoute = ({ children }) => {
  const token = getAuthToken();

  if (token) {
    // Redirect to dashboard if user is already logged in
    return <Navigate to="/app/dashboard" replace />;
  }

  return children;
};

export default PublicRoute; 